import { useAtomValue, useSetAtom } from "jotai";
import {
    balanceSheetMetricsAtom,
    balanceSheetResolutionAtom,
} from "../../../metrics.state";
import { MemoTable } from "../../../components/MemoTable";
import { useCallback } from "react";
import { CellClickedEvent } from "ag-grid-enterprise";
import { MetricsType } from "../../../metrics.types";
import { PeriodSelector } from "../../../components/PeriodSelector";
import { AIMContextViewAtom } from "../../../state/context.state";
import { AIMViewType } from "../../../InvestmentMemo.types";
import { BSSummaryColumnAtom, BSSummaryDataAtom } from "./BSSummary.state";
import { SummaryRow } from "../SummaryFinancials.types";
import { defaultColDef } from "../defaultColDef";

export function BalanceSheetSummary() {
    const metrics = useAtomValue(balanceSheetMetricsAtom);
    const resolution = useAtomValue(balanceSheetResolutionAtom);
    const data = useAtomValue(BSSummaryDataAtom);
    const columns = useAtomValue(BSSummaryColumnAtom);
    const setAIMContextView = useSetAtom(AIMContextViewAtom);
    const handleClick = useCallback(
        (params: CellClickedEvent<SummaryRow>) => {
            const field = params.colDef.field;
            if (field === "label" || !params.data?.metric || !field) return;

            if (field === "popChange" && params.data.popChange) {
                setAIMContextView({
                    type: AIMViewType.DELTA_LINEAGE,
                    props: {
                        metric: params.data.metric,
                        metricLabel: params.data.label,
                        currentSlice: params.data.currentSlice,
                        previousSlice: params.data.previousSlice,
                        popChange: params.data.popChange,
                        fieldType: params.data.fieldType,
                        resolutionWindow: resolution.window || "",
                        popLabel: params.colDef.headerName,
                    },
                });
                return;
            } else {
                setAIMContextView({
                    type: AIMViewType.VALUE_LINEAGE,
                    metric: params.data.metric,
                    period: field,
                    title: params.data.label,
                });
            }
        },
        [metrics, resolution, setAIMContextView],
    );

    return (
        <div id="summary-balance-sheet" className="space-y-3">
            <div className="flex items-center justify-between">
                <h4 className="heading-m">Summary Balance Sheet</h4>
                <PeriodSelector
                    resolutionAtom={balanceSheetResolutionAtom}
                    metricsType={MetricsType.BALANCE_SHEET}
                />
            </div>
            <MemoTable
                data={data}
                columns={columns}
                onCellClicked={handleClick}
                defaultColDef={defaultColDef}
            />
        </div>
    );
}
